import React from "react";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import "../../styles/components/Editor.scss";
import "../../styles/components/EditorModal.scss";
import Button from "@mui/material/Button";

const RSDDialogueModal = ({ setshowRSDProgress, showRSDProgress

}) => {
    return (
        <Dialog
            open={showRSDProgress}
            onClose={() => setshowRSDProgress(false)}
            className="rsd-modalTemp delete-modal"
            aria-labelledby="form-dialog-title"
            overlayStyle={{ backgroundColor: "transparent" }}>
            <DialogContent>
                <div className="delete-modalheading">
                    <span style={{ fontWeight: 700, fontSize: "14px", color: "#1E1E1E" }}>{"RSD Generation in PROGRESS"}</span>
                </div>
                <hr style={{ height: "1px", backgroundColor: "#DDDFDD", position: "relative", top: "15px", left: "-25px", width: "114%" }} />
                <div className="delete-modalSubHeading" style={{ fontWeight: "600", fontSize: "14px", color: "#1E1E1E", marginBottom: "10px" }}>
                    You will be notified via your email once completed.

                </div>
                <div style={{ fontWeight: "600", color: "#878888", fontSize: "12px" }}>Note: Editing banner can clicking on GENERATE RSD, will lead
                    to creation of new RSD.</div>
                <div className="delete-modalContent"></div>
            </DialogContent>
            <hr style={{ height: "1px", backgroundColor: "#DDDFDD", position: "relative", top: "15px", left: "-25px", width: "114%" }} />
            <DialogActions className="delete-actionsTemp" style={{ height: "60px", paddingTop: "16px !important" }}>
                <Button onClick={() => { }} color="primary" className="no-btn">

                </Button>

                <Button
                    onClick={() => {
                        setshowRSDProgress(false)
                    }}
                    type="submit"
                    className="btn btn-primary"
                    style={{ minWidth: "96px" }}
                    autoFocus
                >
                    OK, GOT IT
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default RSDDialogueModal;
